import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import DietRestrictionGuest from './DietRestrictionGuest';
import T from '../Translate';

class DietRestrictions extends Component {

	render() {
		const { totalNoOfGuests } = this.props;

		return (
			<fieldset className="fieldset">
				<legend><T id="GuestDetails.dietRestriction" /></legend>
				{Array.from({ length: totalNoOfGuests }, (_, i) => <DietRestrictionGuest key={i} index={i} />)}
			</fieldset>
		);
	}
}

export default compose(
	connect(state => ({
		totalNoOfGuests: state.app.totalNoOfGuests,
	})),
)(DietRestrictions);



// WEBPACK FOOTER //
// ./src/components/DietRestrictions/index.jsx